/**
 * 404提示组件
 *
 * 显示资源未找到的提示信息
 */

import React from 'react';

interface NotFoundMessageProps {
  /** 提示标题 */
  title?: string;
  /** 提示消息 */
  message?: string;
  /** 自定义类名 */
  className?: string;
}

export const NotFoundMessage: React.FC<NotFoundMessageProps> = ({
  title = '未找到资源',
  message = '您访问的资源不存在或已被删除',
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <div className="text-gray-300 mb-4">
        <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-500 text-center max-w-md">{message}</p>
    </div>
  );
};

export default NotFoundMessage;